import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class CustomerService {
  async getAll (queryData) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/customer`,
        { headers: token, params: { ...queryData } }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async getCustomerInformation (id) {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/customer/${id}`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateStatus (rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/customer/update/status/${rowClicked.id}`,
        headers: { Authorization: token.Authorization },
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteCustomer (rowClicked) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/customer/${rowClicked.id}`,
        { headers: token }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async storeCustomer (data) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/customer`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateCustomer (id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/customer/${id}`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async updateCustomerOrders (data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/customer/updateorder/order`,
        headers: { Authorization: token.Authorization },
        data: {
          data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new CustomerService()
